import { useSearchParams } from "react-router-dom";

export const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setQueryParam = (key: string, value: string | null) => {
    if (value) {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }
    setSearchParams(searchParams);
  };

  const getQueryParam = (key: string) => {
    return searchParams.get(key);
  };

  const deleteQueryParam = (key: string) => {
    searchParams.delete(key);
    setSearchParams(searchParams);
  };

  const checkQueryParam = (paramName: string) => {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.has(paramName);
  };

  return {
    searchParams,
    setQueryParam,
    getQueryParam,
    deleteQueryParam,
    checkQueryParam,
  };
};
